export default __webpack_public_path__ + "static/cafe_36027-92c327521b5fbab18a9ed8cc4b03255f.png";